import React, { useState, useEffect } from "react";
import Lottie from "react-lottie";
import { useMediaQuery } from "@mui/material";
import BackgroundImage from "/Images/Background.svg";
import Custody from "/Images/xcrowiconhero.svg";
import animationData from "../LandingPage/animatednewest.json";

const assets = [
  { text: "digital assets", color: "#F4E37B" },
  { text: "blockchain investments", color: "#A1D6E2" },
  { text: "tokenized assets", color: "#FF6B6B" },
];

const HeroSection = () => {
  const [currentAssetIndex, setCurrentAssetIndex] = useState(0);
  const [animationKey, setAnimationKey] = useState(0);
  const isMobile = useMediaQuery("(max-width: 767px)");

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentAssetIndex((prevIndex) => (prevIndex + 1) % assets.length);
      setAnimationKey((prevKey) => prevKey + 1);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const styles = {
    buttonContainer: {
      display: "flex",
      justifyContent: "left",
      marginTop: "30px",
    },
    button: {
      backgroundColor: "#F4E37B",
      color: "#214D73",
      padding: isMobile ? "10px 20px" : "15px 30px",
      borderRadius: "8px",
      border: "none",
      fontSize: isMobile ? "0.875rem" : "1rem",
      cursor: "pointer",
      textDecoration: "none",
      display: "inline-block",
    },
  };

  return (
    <section
      style={{
        backgroundImage: `url(${BackgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: isMobile ? "0 2.5rem" : "0 6rem",
        paddingTop: isMobile ? "3rem" : "12rem",
        paddingBottom: isMobile ? "18rem" : "20rem",
        color: "#FFFFFF",
        maxHeight: "812px",
        position: "relative",
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        alignItems: isMobile ? "center" : "flex-start",
      }}
    >
      {/* Lottie Animation - Positioned above content for mobile view */}
      {!isMobile && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            right: 0,
            transform: "translateY(-50%)",
            maxWidth: "3000px",
            overflow: "hidden",
            marginLeft: "300px",
            marginRight: "0px",
            marginTop: "40px",
          }}
        >
          <Lottie options={defaultOptions} width="850px" height="700px" />
        </div>
      )}

      {/* Text Content */}
      <div
        style={{
          flex: 1,
          maxWidth: isMobile ? "600px" : "450px",
          marginLeft: 0,
          marginRight: isMobile ? "0px" : "120px",
          paddingTop: isMobile? "100px" : "0",
          textAlign: "left", // Left-align title text on mobile
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "30px",
            justifyContent: "flex-start",
            textAlign: "left", // Left-align paragraph text on mobile

          }}
        >
          <img
            src={Custody}
            alt="Custody Icon"
            style={{ height: isMobile ? "30px" : "40px", marginRight: "10px" }}
          />
          <h2
            style={{
              fontSize: isMobile ? "24px" : "40px",
              fontWeight: "bold",
              color: "#FFFFFF",
              margin: 0,
              marginLeft: "10px",
            }}
          >
            Xcrow
          </h2>
        </div>

        <h1
          style={{
            fontSize: isMobile ? "24px" : "50px",
            fontWeight: 550,
            lineHeight: "1.2",
            marginBottom: isMobile ? "20px" : "50px",
            textAlign: "left",
          }}
        >
          <span> A Trusted Escrow </span> <br />
          <span style={{ color: "#F4E37B" }}>Crypto Service</span>
        </h1>

        <p
          style={{
            fontSize: isMobile ? "14px" : "22px",
            color: "#E7E4E2",
            marginBottom: isMobile ? "20px" : "30px",
            minWidth: isMobile ? "auto" : "762px",
            textAlign:  "left",
          }}
        >
          A best partner crypto escrow service used as a <br />
          market place service to handle stablecoin.
        </p>
        <div style={isMobile ? styles.buttonContainer : {}}>
          <a href="#contact" style={styles.button}>
            Find out more
          </a>
        </div>
      </div>

      {/* Lottie Animation - Positioned to the side for desktop view */}
      {isMobile && (
        <div
          style={{
            position: "absolute",
            maxWidth: "250px",
            zIndex: 1, // Ensures the animation is on top
            top: "320px",
            right: "190px",
          }}
        >
          <Lottie options={defaultOptions} width="500px" height="400px" />
        </div>
      )}
     
    </section>
  );
};

export default HeroSection;
